<template>
  <div id="preview" class="summary" v-if="summary">
    <div class="printTitle"><span>{{range.start}} </span><span v-if="range.start!==range.end">~</span><span v-if="range.start!==range.end"> {{ range.end }}</span> 品項統計 <span v-if="sort==='productionDate'">[排單日]</span></div>
    <div class="printCount">
      <div></div>
      <div>總人數: {{summary.all}}</div>
      <div>大人: {{summary.a}}</div>
      <div>小孩: {{summary.c}}</div>
      <div></div>
    </div>
    <div class="printBody" :style="{paddingBottom: '20px', marginBottom: '20px', borderBottom: '1px solid #999999'}">
      <div class="eachItem" >
        <div>
          <div>桌菜</div>
          <div>數量</div>
        </div>
        <div v-for="(row, r) in tabs" :key="`tb-0-${r}`">
          <div>
            <div>{{row.name}}</div>
            <div>{{row.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" >
        <div>
          <div>套餐</div>
          <div>數量</div>
        </div>
        <div v-for="(row, r) in sets" :key="`tb-s-${r}`">
          <div>
            <div>{{row.name}}</div>
            <div>{{row.count}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="printBody">
      <div class="eachItem" v-for="(row, r) in tabs" :key="`tb-${r}`">
        <div><div>{{row.name}}</div>
            <div>x{{row.count}}</div></div>
        <div v-for="(item, i) in row.items" :key="`item-${r}-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" v-for="(row, r) in sets" :key="r">
        <div><div>{{row.name}}</div>
            <div>x{{row.count}}</div></div>
        <div v-for="(item, i) in row.items" :key="`item-${r}-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="printTitle"><span>{{range.start}} </span><span v-if="range.start!==range.end">~</span><span v-if="range.start!==range.end"> {{ range.end }}</span> 品項統計 - 菜品</div>
    <div class="printBody">
      <div class="eachItem" v-if="tabs&&tabsSingle[0]?.items?.length>0">
        <div>桌菜</div>
        <div v-for="(item, i) in tabsSingle[0]?.items.slice(0, tabsSingle[0]?.items.length > 20 ? Math.ceil(tabsSingle[0]?.items.length / 2) : 20)" :key="`item-tabs-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" v-if="tabs&&tabsSingle[0]?.items.length>20">
        <div>桌菜</div>
        <div v-for="(item, i) in tabsSingle[0]?.items?.slice(tabsSingle[0]?.items.length > 20 ? Math.ceil(tabsSingle[0]?.items.length / 2) : 20)" :key="`item-tabs2-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" v-if="sets&&setsSingle[0]?.items?.length>0">
        <div>套餐</div>
        <div v-for="(item, i) in setsSingle[0]?.items.slice(0, setsSingle[0]?.items.length > 20 ? Math.ceil(setsSingle[0]?.items.length / 2) : 20)" :key="`item-set-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" v-if="sets&&setsSingle[0]?.items.length>20">
        <div>套餐</div>
        <div v-for="(item, i) in setsSingle[0]?.items?.slice(setsSingle[0]?.items.length > 20 ? Math.ceil(setsSingle[0]?.items.length / 2) : 20)" :key="`item-set-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="eachItem" v-if="singles.length>0">
        <div>單點</div>
        <div v-for="(item, i) in singles" :key="`item-single-${i}`">
          <div>
            <div>{{item.name}}</div>
            <div>{{item.count}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['summary', 'range', 'sort'],
  computed: {
    sets () {
      return this.getCollOrders(this.summary.sets)
    },
    tabs () {
      return this.getCollOrders(this.summary.tabs)
    },
    singles () {
      return this.getCollOrders(this.summary.singles)
    },
    setsSingle () {
      const sets = JSON.parse(JSON.stringify(this.summary.sets)).map(e => {
        return { ...e, t: 'set', sid: '1', name: '套餐' }
      })
      // console.log('===== setsSingle =====')
      // console.table(sets)
      // console.table([].concat(...sets.map(e => e.items.map(a => a.item))))
      return (sets && sets.length > 0) ? this.getCollOrders(sets) : []
    },
    tabsSingle () {
      const sets = JSON.parse(JSON.stringify(this.summary.tabs)).map(e => {
        return { ...e, t: 'set', sid: '1', name: '桌菜' }
      })
      // console.log('===== tabsSingle =====')
      // console.table(sets)
      return (sets && sets.length > 0) ? this.getCollOrders(sets) : []
    }
  }

}
</script>

<style id="printRestInstore">
.printBody {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 30px;
}
.eachItem {
  display: flex;
  flex-direction: column;
  border: 1px solid #CACACA;
  margin-top: 10px;
  min-height: 85px;
  page-break-inside: avoid;
  align-items: center;
  justify-content: flex-start;
}
.eachItem>div:nth-child(1) {
  font-size: 20px;
  font-weight: 700;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #CACACA;
  width: calc(100% - 20px);
}
.eachItem>div:not(:first-child) {
  width: 100%;
  padding: 5px 10px;
}
.eachItem>div:not(:first-child)>div {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}
</style>
